import { NgModule } from '@angular/core';
import { OAuthModule } from 'angular-oauth2-oidc'
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RequestsComponent } from './requests/requests.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RequestComponent } from './requests/request/request.component';
import { TasksComponent } from './tasks/tasks/tasks.component';
import { TaskComponent } from './tasks/task/task.component';
import { OpenTaskListComponent } from './tasks/task-list/open-task-list/open-task-list.component';
import { RequestedTaskListComponent } from './tasks/task-list/requested-task-list/requested-task-list.component';
import { OpenRequestListComponent } from './requests/requests-list/open-request-list/open-request-list.component';
import { ClosedRequestListComponent } from './requests/requests-list/closed-request-list/closed-request-list.component';
import { HomeComponent } from './home/home/home.component';
import { HeaderComponent } from './header/header.component';
import { CreateComponent } from './requests/create/create.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LoadingComponent } from './common/loading/loading.component';
import { MatDialogModule } from '@angular/material/dialog';
import { OrganisationComponent } from './organisation/organisation/organisation.component';
import { DialogComponent } from './dialog/dialog.component';
import { AllTaskListComponent } from './tasks/task-list/all-task-list/all-task-list.component';
import { AllRequestListComponent } from './requests/requests-list/all-request-list/all-request-list.component';
import { SubmitComponent } from './feedback/submit/submit.component';
import { ListComponent } from './feedback/list/list.component';
import { RelatedRequestsComponent } from './requests/requests-list/related-requests/related-requests.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BadgeComponent } from './common/badge/badge.component';
import { TextJustificationComponent } from './tasks/justifications/text-justification/text-justification.component';
import { RequestStatisticsComponent } from './requests/stats/request-statistics/request-statistics.component';
import { RequestReviewersComponent } from './requests/request-reviewers/request-reviewers.component';
import { RequestModeratorsComponent } from './requests/request-moderators/request-moderators.component';
import { TaskStatisticsComponent } from './tasks/stats/task-statistics/task-statistics.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ErrorComponent } from './common/error/error.component';
import { TaskQueryComponent } from './requests/create/task-query/task-query.component';
import { CreatedComponent } from './requests/created/created.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GroupByPipe } from './common/group-by.pipe';
import { RequestorFeedbackComponent } from './feedback/requestorSubmit/requestor.feedback/requestor.feedback.component';
import { ReviewerspertaskComponent } from './tasks/reviewerspertask/reviewerspertask.component';
import { HealthComponent } from './health/health.component';
import { GraphComponent } from './common/graph/graph.component';
import { RefreshComponent } from './common/refresh/refresh.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { EditorComponent, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { SafeHtmlPipe } from './common/safe-htmlpipe/safe-html.pipe';
import { TrimHtmlcontentPipe } from './common/trimmed-pipe/trim-htmlcontent.pipe';
import { RequestDetailDialogComponent } from './requests/request-detail-dialog/request-detail-dialog.component';
import { RequestDetailPageComponent } from './requests/request-detail-page/request-detail-page.component';
import { TaskDetailDialogComponent } from './tasks/task-detail-dialog/task-detail-dialog.component';
import { TaskDetailPageComponent } from './tasks/task-detail-page/task-detail-page.component';

@NgModule({
  declarations: [
    AppComponent,
    RequestsComponent,
    RequestComponent,
    TasksComponent,
    TaskComponent,
    OpenTaskListComponent,
    RequestedTaskListComponent,
    OpenRequestListComponent,
    AllRequestListComponent,
    AllTaskListComponent,
    ClosedRequestListComponent,
    HomeComponent,
    HeaderComponent,
    CreateComponent,
    LoadingComponent,
    OrganisationComponent,
    DialogComponent,
    SubmitComponent,
    ListComponent,
    RelatedRequestsComponent,
    BadgeComponent,
    TextJustificationComponent,
    RequestStatisticsComponent,
    TaskStatisticsComponent,
    RequestReviewersComponent,
    RequestModeratorsComponent,
    ErrorComponent,
    TaskQueryComponent,
    CreatedComponent,
    GroupByPipe,
    RequestorFeedbackComponent,
    ReviewerspertaskComponent,
    HealthComponent,
    GraphComponent,
    RefreshComponent,
    ConfigurationComponent,
    SafeHtmlPipe,
    TrimHtmlcontentPipe,
    RequestDetailDialogComponent,
    RequestDetailPageComponent,
    TaskDetailDialogComponent,
    TaskDetailPageComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    EditorComponent,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatTabsModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatTooltipModule,
    OAuthModule.forRoot()
  ],
  providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
